import { EMPTY_STRING } from '../constants/common'

import { isDevelopmentEnvironment } from './common'

/*
 * Not constants but a mutable module-level cache: the version is fetched once
 * per session and must be readable synchronously (`getHeaders` reads it on
 * every request), so the state has to outlive function calls and live next to
 * the functions that close over it.
 */
let appVersion = EMPTY_STRING
let appVersionPromise = null

export function getAppVersion() {
  return appVersion
}

/*
 * The build version exists only in built environments (nginx serves
 * `build_version.txt`), so on localhost the version stays empty and the
 * `X-App-Version` header is not sent.
 */
export async function loadAppVersion() {
  if (isDevelopmentEnvironment()) {
    return appVersion
  }

  if (!appVersionPromise) {
    appVersionPromise = fetch('/build_version.txt', { cache: 'no-store' })
      .then(async response => {
        const text = response.ok ? await response.text() : EMPTY_STRING

        appVersion = text.split('\n')[0]

        return appVersion
      })
      .catch(() => {
        appVersionPromise = null

        return appVersion
      })
  }

  return appVersionPromise
}
